module.exports = __webpack_public_path__ + "statics/img/success-oem.7cd03ad1.svg";